import { Component, ViewChild, ElementRef, Input, Output, NgZone, OnDestroy, ApplicationRef } from '@angular/core';
import { ScrollDispatcher } from '@angular/cdk/scrolling';
import { Subscription } from 'rxjs';

import { QueryService, UiModalService } from '@app/core/services';
import { configUrl } from '@env/environment';
import { User } from '@app/shared/model';
import { format, parseISO } from 'date-fns';

@Component({
  selector: 'app-modal-session-list',
  templateUrl: './modal-session-list.component.html',
})
export class ModalSessionListComponent implements OnDestroy {
  @ViewChild('sessionsList') sessionsList: ElementRef;

  @Input() actionTitle = $localize`Action`;
  @Input() modalTitle = $localize`:@@posts:Posts`;
  @Input() sessions: any = {};
  @Output() actionCallback: (post: any) => void;

  listTopShadow = false;
  listBottomShadow = false;

  configUrl = configUrl;

  scrollDispatcherSubscription: Subscription;

  constructor(
    private modal: UiModalService,
    private scrollDispatcher: ScrollDispatcher,
    private zone: NgZone,
    private appRef: ApplicationRef,
    public qs: QueryService,
  ) {
    this.scrollDispatcherSubscription = this.scrollDispatcher.scrolled().subscribe((x) => {
      this.updateListShadows();
    });
  }

  ngOnDestroy() {
    this.scrollDispatcherSubscription?.unsubscribe();
  }

  updateListShadows() {
    const element = this.sessionsList?.nativeElement;

    const listTopShadow = this.sessionsList && element.scrollTop > 0;
    const listBottomShadow = this.sessionsList && element.scrollTop < element.scrollHeight - element.clientHeight;

    if (this.listTopShadow !== listTopShadow || this.listBottomShadow !== listBottomShadow) {
      this.zone.run((_) => {
        this.listTopShadow = listTopShadow;
        this.listBottomShadow = listBottomShadow;
      });
    }
  }

  dismiss() {
    this.modal.destroy();
  }

  performAction(post: any) {
    this.actionCallback(post);
    this.modal.destroy();
  }

  formatDate(date) {
    return format(parseISO(date), 'd MMM yyyy k:mm');
  }
}
